"use client";
import React, { useState, useEffect } from "react";
import Loader from "../Loader/Loader";
import ImageGallery from "react-image-grid-gallery";
import "./Autografika.css";
import Navbar from "../Navbar/Navbar";
import LijeviMeni from "../Pocetna/LijeviMeni";
import Footer from "../Pocetna/Footer/Footer";
import "./stirodur.css";

const importAll = (r) => r.keys().map(r);
const stirodurNatpisiImages = importAll(
  require.context("../../assets/promotivniMaterijal", false, /\.(webp)$/i)
);

const PromoMaterijal = () => {
  const [isContentLoaded, setIsContentLoaded] = useState(false);
  const [buttonText, setButtonText] = useState("Pročitaj više");

  useEffect(() => {
    const fakeApiCall = setTimeout(() => {
      setIsContentLoaded(true);
    }, 1000);

    return () => clearTimeout(fakeApiCall);
  }, []);

  const imagesArray = stirodurNatpisiImages.map((image, index) => ({
    alt: `Image${index + 1}'s alt text`,
    src: image,
  }));

  const [isParagraphVisible, setIsParagraphVisible] = useState(false);

  const handleButtonClick = () => {
    setIsParagraphVisible(!isParagraphVisible);
    setButtonText(
      isParagraphVisible ? "Pročitaj više" : "Zatvori dodatni tekst"
    );
  };

  return (
    <div>
      {!isContentLoaded ? (
        <Loader />
      ) : (
        <>
          <Navbar />
          <div className="autografika-main">
            <div className="container">
              <div className="row reverse" id="usluge-navi">
                {/* Left column for */}
                <LijeviMeni />
                {/* Right column for */}
                <div className="col-md-8 bg">
                  <h1>Promotivni materijal</h1>{" "}
                  <div className="autografika-opis">
                    <div className="vise-button">
                      <button
                        type="button"
                        className="btn btn-dark"
                        onClick={handleButtonClick}
                      >
                        {buttonText}
                      </button>
                    </div>

                    {isParagraphVisible && (
                      <>
                        <p>
                          Grafik takođe nudi širok izbor promotivnog materijala
                          od kojeg izdvajamo:
                        </p>

                        <ul>
                          <li>
                            <strong>Brendirane majice (t-shirt i polo)</strong>
                          </li>
                          <li>
                            <strong>Printane okovratne trakice</strong>
                          </li>
                          <li>
                            <strong>Olovke sa kolor ispisom</strong>
                          </li>
                          <li>
                            <strong>Upaljači sa kolor ispisom</strong>
                          </li>
                          <li>
                            <strong>3D stikeri od smole</strong>
                          </li>
                          <li>
                            <strong>Pjenasti privjesci</strong>
                          </li>
                          <li>
                            <strong>Auto mirisi</strong>
                          </li>
                          <li>
                            <strong>Eko cegeri sa printom</strong>
                          </li>
                          <li>
                            <strong>Stolne zastavice</strong>
                          </li>
                          <li>
                            <strong>Bedževi</strong>
                          </li>
                        </ul>
                      </>
                    )}
                  </div>
                  <div className="stirodur-grid">
                    <ImageGallery
                      imgArray={imagesArray}
                      columnWidth={230}
                      gapSize={4}
                    />
                  </div>
                  <div className="stirodur-grid-mobile">
                    <ImageGallery
                      imgArray={imagesArray}
                      columnWidth={230}
                      gapSize={4}
                    />
                  </div>
                  <div className="display-text-mobile">
                    <p>
                      Grafik takođe nudi širok izbor promotivnog materijala od
                      kojeg izdvajamo:
                    </p>

                    <ul>
                      <li>
                        <strong>Brendirane majice (t-shirt i polo)</strong>
                      </li>
                      <li>
                        <strong>Printane okovratne trakice</strong>
                      </li>
                      <li>
                        <strong>Olovke sa kolor ispisom</strong>
                      </li>
                      <li>
                        <strong>Upaljači sa kolor ispisom</strong>
                      </li>
                      <li>
                        <strong>3D stikeri od smole</strong>
                      </li>
                      <li>
                        <strong>Pjenasti privjesci</strong>
                      </li>
                      <li>
                        <strong>Auto mirisi</strong>
                      </li>
                      <li>
                        <strong>Eko cegeri sa printom</strong>
                      </li>
                      <li>
                        <strong>Stolne zastavice</strong>
                      </li>
                      <li>
                        <strong>Bedževi</strong>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <Footer />
          </div>
        </>
      )}
    </div>
  );
};

export default PromoMaterijal;
